import { CpaStatus } from '../../../data-layer/cpa/types';

export const WALLET_RELEVANT_STATUSES = [CpaStatus.TRIAL, CpaStatus.ACCEPTED];

export const HIDE_BUTTON_STATUSES = [
    CpaStatus.NOT_REGISTERED,
    CpaStatus.WAIT_REGISTRATION,
    CpaStatus.TRIAL_EXPIRED,
];
